import { ZodTypeAny } from 'zod'
import { TValidator } from './validators'

export const fromZod = <S extends ZodTypeAny>(
  schema: S,
): TValidator<unknown> => {
  return (it: unknown) => {
    const data = schema.safeParse(it)
    if (data.success) return

    const { message, path } = data.error.errors[0]
    const pathStr = path
      .map(it => (typeof it === 'string' ? `.${it}` : `[${it}]`))
      .join('')

    return `${message} (at ${pathStr})`
  }
}
